export const TWO_COLUMNS_BREAKPOINT = 1140;
export const ONE_COLUMN_BREAKPOINT = 619;

export enum LayoutColumn {
  Left = 'left',
  Middle = 'middle',
  Right = 'right',
}
